import { apiPost } from '../../api'

export const add_category = data => {
  return apiPost({
    endpoint: 'events/save_category',
    data: data
  })
}
